import Dashboard from "views/pages/Dashboard.js"
import Login from "views/pages/Login.js"
import Profile from "views/pages/Profile.js"
import Register from "views/pages/Register.js"
import ForgotPassword from "views/pages/ForgotPassword.js"
import EmailActions from "views/pages/EmailActions.js"
import Users from "views/admin/Users.jsx"
import AddUsers from "views/admin/AddUsers.jsx"
import Merchants from "views/admin/Merchants.jsx"
import AddMerchants from "views/admin/AddMerchants.jsx"
import Orders from "views/admin/Orders.jsx"
import PromoCodes from "views/admin/PromoCodes.jsx"

const routes = [
  {
    name: "Dashboard",
    icon: "fas fa-columns text-primary",
    path: "/dashboard",
    component: Dashboard,
    layout: "/d",
    visible: true,
  },
  {
    collapse: true,
    name: "Users",
    icon: "fas fa-users text-primary",
    state: "usersCollapse",
    views: [
      {
        path: "/users",
        name: "All Users",
        miniName: "D",
        component: Users,
        layout: "/d",
        visible: true,
      },
      {
        path: "/user/add",
        name: "Add Users",
        miniName: "A",
        component: AddUsers,
        layout: "/d",
        visible: true,
      },
    ],
  },
  {
    collapse: true,
    name: "Merchants",
    icon: "fas fa-store text-primary",
    state: "vendorsCollapse",
    views: [
      {
        path: "/merchants",
        name: "All Merchants",
        miniName: "D",
        component: Merchants,
        layout: "/d",
        visible: true,
      },
      {
        path: "/merchant/add",
        name: "Add Merchant",
        miniName: "A",
        component: AddMerchants,
        layout: "/d",
        visible: true,
      },
    ],
  },
  {
    name: "Orders",
    icon: "fas fa-receipt text-primary",
    path: "/orders",
    component: Orders,
    layout: "/d",
    visible: true,
  },
  {
    name: "Promo Codes",
    icon: "fas fa-ticket-alt text-primary",
    path: "/promos",
    component: PromoCodes,
    layout: "/d",
    visible: true,
  },
  {
    path: "/login",
    name: "Login",
    miniName: "L",
    component: Login,
    layout: "/a",
    visible: false,
  },
  {
    path: "/register",
    name: "Register",
    miniName: "R",
    component: Register,
    layout: "/a",
    visible: false,
  },
  {
    path: "/profile",
    name: "Profile",
    miniName: "P",
    component: Profile,
    layout: "/d",
    visible: false,
  },
  {
    path: "/forgot",
    name: "Forgot Password",
    miniName: "F",
    component: ForgotPassword,
    layout: "/a",
    visible: false,
  },
  {
    path: "/emailActions",
    name: "Email Actions",
    miniName: "EA",
    component: EmailActions,
    layout: "/a",
    visible: false,
  },
]

export default routes
